import { useTranslation } from 'react-i18next';
import useFundContext from '@/contexts/Fund/useFundContext';
import ShareableLinks from './ShareableLinks';
import QuickButtonsEditor from './QuickButtonsEditor';
import NotificationSettings from './NotificationSettings';
import LogoUploader from './LogoUploader';
import styles from './DonationsAdmin.module.css';

const DonationSettingsPage = () => {
  const { t } = useTranslation();
  const { currentFund } = useFundContext();

  if (!currentFund) return <h1>{t('noFundSelected')}.</h1>;

  return (
    <div className={styles.container}>
      <h1 className={styles.pageTitle}>{t('donations.admin.settingsTitle')}</h1>
      <LogoUploader fundId={currentFund.id} />
      <ShareableLinks fundId={currentFund.id} />
      <QuickButtonsEditor fundId={currentFund.id} />
      <NotificationSettings fundId={currentFund.id} />
    </div>
  );
};

export default DonationSettingsPage;
